import type { ProjectPageFormValues } from '@/lib/validation/projectPage'
import type { ProjectPageFormData } from '@/types/projectPages'

export function toProjectPageFormData(values: ProjectPageFormValues): ProjectPageFormData {
  return {
    ...values,
    gallery_images: values.gallery_images ?? undefined,
    schema_json: values.schema_json ?? undefined,
    related_project_ids: values.related_project_ids ?? undefined
  }
}

